import { render, staticRenderFns } from "./comment-default.vue?vue&type=template&id=f8bceb2c"
import script from "./comment-default.vue?vue&type=script&lang=js"
export * from "./comment-default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports